<template>
  <div style="text-align: left">
    <el-form ref="form" :model="form" label-width="100px">
      <el-form-item>
        <el-row type="flex" justify="space-between">
          <el-col :span="4">
            <el-select v-model="form.status" placeholder="请选择">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="待审核" :value="0"></el-option>
              <el-option label="已驳回" :value="1"></el-option>
              <el-option label="已通过" :value="2"></el-option>
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" @click="onQuery"><i class="el-icon-search"></i> 查询</el-button>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>

    <el-table
      :data="veteranList"
      border
      style="width: 100%">
      <el-table-column
        prop="customerId"
        label="用户编号">
      </el-table-column>
      <el-table-column
        prop="name"
        label="姓名">
      </el-table-column>
      <el-table-column
        prop="certificate"
        label="证件照片">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.certificate"
            :src="scope.row.certificate"
            :preview-src-list="[scope.row.certificate]"
            style="width: 60px; height: 60px;"
            fit="cover">
          </el-image>
          <span v-else>-</span>
        </template>
      </el-table-column>
      
      <el-table-column
        prop="status"
        label="状态">
        <template slot-scope="scope">
          <el-tag
            :type="getStatusTag(scope.row.status)"
            disable-transitions>{{getStatusText(scope.row.status)}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status == 0"
            type="success"
            size="small"
            @click="handlePass(scope.row.customerId)">通过</el-button>
          <el-button
            v-if="scope.row.status == 0"
            type="danger"
            size="small"
            @click="showRejectDialog(scope.row.customerId)">驳回</el-button>
          <span v-else>-</span>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="pagination"
      background
      layout="prev, pager, next"
      @current-change="handlePageChange"
      :current-page.sync="form.page"
      :page-size="form.pageSize"
      :total="totalElements">
    </el-pagination>

    <el-dialog
      title="驳回原因"
      :visible.sync="rejectDialogVisible"
      width="400px">
      <el-input v-model="rejectReason" type="textarea" :rows="3" placeholder="请输入驳回原因"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="rejectDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleReject">确定驳回</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as api from "@/js/api.js";

export default {
  name: "VeteranList",
  data() {
    return {
      form: {
        status: undefined,
        page: 1,
        pageSize: 16
      },
      veteranList: [],
      totalElements: 0,
      rejectDialogVisible: false,
      rejectReason: '',
      currentAuditCustomerId: null,
    }
  },
  methods: {
    handlePageChange() {
      this.onQuery()
    },
    handleSizeChange(val) {
      this.form.pageSize = val
      this.onQuery()
    },
    onQuery() {
      const query = {}
      if (this.form.status !== undefined) query.status = this.form.status
      query.page = this.form.page
      query.pageSize = this.form.pageSize

      api.queryVeteran(query).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('查询老兵记录出错');
        } else {
          this.veteranList = result.data.content
          this.totalElements = result.data.totalElements
        }
      })
    },
    getStatusText(status) {
      const map = {
        0: '待审核',
        1: '已驳回',
        2: '已通过'
      }
      return map[status] || '未知'
    },
    getStatusTag(status) {
      const map = {
        0: 'warning',
        1: 'danger',
        2: 'success'
      }
      return map[status] || 'info'
    },
    handlePass(customerId) {
      this.$confirm('确定要通过该老兵申请吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.auditVeteran({ customerId: customerId, status: 2, reason: '' }).then(res => {
          let result = res.data
          if (result.error) {
            this.$message.error('审核操作失败');
          } else {
            this.$message.success('通过成功');
            this.onQuery()
          }
        })
      }).catch(() => {
        this.$message.info('已取消操作');
      })
    },
    showRejectDialog(customerId) {
      this.currentAuditCustomerId = customerId
      this.rejectReason = ''
      this.rejectDialogVisible = true
    },
    handleReject() {
      api.auditVeteran({ customerId: this.currentAuditCustomerId, status: 1, reason: this.rejectReason }).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('审核操作失败');
        } else {
          this.$message.success('驳回成功');
          this.rejectDialogVisible = false
          this.onQuery()
        }
      })
    }
  },
  mounted() {
    this.form.status = 0
    this.onQuery()
  },
}
</script>

<style scoped>
.pagination {
  margin-top: 15px;
}
</style>


// WEBPACK FOOTER //
// src/pages/veteran/VeteranList.vue